import React, { useState } from "react"
import { useMutation } from "@apollo/client"
import { INote } from "../interface"
import { FaEraser } from "react-icons/fa"
import ModalForm from "../components/ModalForm"
import Loading from "./Loading"
import Edit from "./Edit"
import { DELETE_NOTE } from "../graphql/DeleteNote"

interface IProps {
  note: INote
  refetch: any
}

const Card: React.FC<IProps> = ({ note, refetch }) => {
  const [showModalForm, setShowModalForm] = useState<boolean>(false)
  const [showEdit, setShowEdit] = useState<boolean>(false)
  const [editInfo, setEditInfo] = useState<INote | null>(null)
  const [deleteNoteMutation, { error, loading }] = useMutation(DELETE_NOTE)

  const clickCardHandle = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    setEditInfo(note)
    setShowEdit(true)
  }

  const deleteHandle = async (noteId: string) => {
    await deleteNoteMutation({
      variables: {
        noteId: noteId,
      },
    })
    refetch()
    setShowModalForm(false)
  }

  if (loading) return <Loading />
  if (error) return <div>Something went wrong</div>

  return (
    <>
      <li
        className='relative z-0 h-40 p-3 border-2 rounded-lg shadow-lg bg-slate-800 border-slate-300/20 hover:cursor-pointer hover:bg-slate-60'
        onClick={(event) => {
          clickCardHandle(event)
        }}
      >
        <h2 className='w-[90%] p-1 text-lg md:text-xl -tracking-normal'>{note.title}</h2>
        <ul className='flex flex-wrap space-x-1 '>
          {note.keyword.split(" ").map((word, index) => {
            return (
              <li key={index} className='text-xs md:text-sm p-1  rounded-sm border-[1px] border-slate-600 font-light'>
                {word}
              </li>
            )
          })}
        </ul>
        <div
          className='pt-2 text-xs break-words md:text-sm'
          dangerouslySetInnerHTML={{
            __html: note.content.slice(0, 80) + "...",
          }}
        />
        <div className='absolute top-0 right-0 flex m-4 space-x-2'>
          <div
            className='relative z-10 p-2 text-red-300 rounded-full bg-slate-800 hover:cursor-pointer hover:text-red-600'
            onClick={(event) => {
              event.stopPropagation()
              setShowModalForm(true)
            }}
          >
            <FaEraser />
          </div>
        </div>
      </li>
      <Edit showEdit={showEdit} setShowEdit={setShowEdit} editInfo={editInfo} refetch={refetch} />
      {showModalForm && (
        <ModalForm
          title='Delete This Note?'
          setShowModalForm={setShowModalForm}
          action={() => {
            deleteHandle(note._id)
          }}
        />
      )}
    </>
  )
}

export default Card
